import classNames from 'classnames';
import React, { FC, MouseEventHandler } from 'react';
import TypographyWrapper from '../../TypographyWrapper/TypographyWrapper';

type CookiePreferencesLinkProps = {
  className?: string;
};

/**
 * Trigger CookieYes cookie consent preferences window.
 * Docs: https://www.cookieyes.com/documentation/add-revisit-consent-button-footer/
 */
export const CookiePreferencesLink: FC<CookiePreferencesLinkProps> = ({ className }) => {
  const COOKIE_YES_REVISIT_COOKIE_SETTINGS_HREF = '#';
  const COOKIE_YES_REVISIT_COOKIE_SETTINGS_CLASS_NAME = 'cky-banner-element';

  // Href of '#' scrolls to the top of the page. We don't need that since this just opens a modal.
  const onClick: MouseEventHandler<HTMLAnchorElement> = (e) => e.preventDefault();

  return (
    <a
      href={COOKIE_YES_REVISIT_COOKIE_SETTINGS_HREF}
      className={classNames(className, COOKIE_YES_REVISIT_COOKIE_SETTINGS_CLASS_NAME)}
      onClick={onClick}
    >
      <TypographyWrapper variant="body1">Cookie Preferences</TypographyWrapper>
    </a>
  );
};
